import { UIFieldType } from '../../entities/UIField';
import { BridgingTextFieldEditor } from './BridgingTextFieldEditor';

export const TextFieldType = UIFieldType({
    name: 'text',
    ui: BridgingTextFieldEditor,
});
